import { FormField, Header, Select, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { CustomAppLayout } from '../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import BookingGrid from '../../../../components/BookingGrid';
import DPModal from '../../../../components/DPModal';
import Confirm from '../../../../components/extras/Confirm';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { useGlobalState } from '../../../context/GlobalStateContext';
dayjs.extend(isBetween);


const pageSize = 20;
interface HourOption {
    value: string;
    label: string;
}
export const AdminBookingsPage = () => {
    const { menu, parameters, idUser, data } = useGlobalState();
    const [bookings, setBookings] = useState<any[]>([]);
    const [blockings, setBlockings] = useState<any[]>([]);
    const [info, setInfo] = useState<any>();




    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setBookings([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        dateBetween: parameters.date,
                        blockings: true,
                        orderBy: "ordenGroupType",
                        order: "ASC",
                        orderBy2: "dateEnd",
                        order2: "ASC"
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.bookings) {
                    setBookings(data.bookings);
                }
                if (data && data.blockings) {
                    setBlockings(data.blockings);
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        handleRefresh();
    }, [parameters.date]);

    return (
        <>
            <CustomAppLayout
                toolsHide={true}
                breadcrumbs={
                    <BreadcrumbGroup
                        items={buildBreadcrumbItems(menu)}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                content={
                    <SpaceBetween size="s">
                        <Header variant="h1" actions={<Favorites />}>Grilla de Reservas</Header>
                        <SpaceBetween size="s" direction="vertical">
                            <SpaceBetween size="s" direction="horizontal">
                                <FormField label="Fecha">

                                    <DPModal width={105} today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                        if (date !== "") {
                                            const updatedParameters = {
                                                ...parameters, // clone existing keys
                                                date: (date) // add or update
                                            };
                                            setParameters(updatedParameters);
                                        }
                                    }} />
                                </FormField>
                                <FormField label="Tipo">
                                    <div style={{ width: 200 }}>
                                        <Select
                                            expandToViewport
                                            options={[
                                                { label: "Todos", value: "0" },
                                                ...(data?.groupTypes?.filter((g: any) => g.showOnBooking === 1) // filter out any falsy values before mapping
                                                    .map((g: any) => ({
                                                        label: g.groupType,
                                                        value: String(g.idGroupType)
                                                    })) || [])
                                            ]}
                                            selectedOption={
                                                Number(parameters.idGroupType) === 0
                                                    ? { label: "Todos", value: "0" }
                                                    : (() => {
                                                        const selected = data?.groupTypes?.find(
                                                            (g: any) => Number(g.idGroupType) === Number(parameters.idGroupType)
                                                        );
                                                        return selected
                                                            ? { label: selected.groupType, value: String(selected.idGroupType) }
                                                            : { label: "Todos", value: "0" };
                                                    })()
                                            }
                                            onChange={(value) => {
                                                const selectedVal = Number(value.detail.selectedOption.value);
                                                setParameters({ ...parameters, idGroupType: selectedVal });
                                            }}
                                        />
                                    </div>
                                </FormField>
                            </SpaceBetween>


                        </SpaceBetween>
                        <BookingGrid bookings={bookings} blockings={blockings} date={parameters.date} showPrivates={true} showOnlyBookings={false}
                        />

                        {!!info && (
                            <Confirm
                                type="info"
                                onDismiss={() => setInfo(null)} show={!!info} action={'Reservar'}
                                warning={`Ir a reservar el ${info?.registration} el ${info?.date} desde las ${info?.startTime}:00`}
                                onConfirm={() => {
                                    window.location.hash = `#members/bookings/book?date=${info?.date}&idGroupType=${info?.idGroupType}&idEquipment=${info?.idEquipment}&startTime=${info?.startTime}&callBack=#members/bookings/planning`;
                                }}
                            />
                        )}
                    </SpaceBetween>
                }
            />
        </>
    )
};
